import { getFlexNode } from '@play-co/timestep-core/flexbox';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import LockedButtonOverlay from './LockedButtonOverlay';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import { AvailableDisabledFeatures } from '../popups/PopupFeatureDisabled';
import sounds from 'src/lib/sounds';
import { isPlatformGuest } from '../../lib/utils';
import platform from '@play-co/gcinstant';

const ui = uiConfig.buruburu.menu;

export type MenuActionType =
  | 'encyclopedia'
  | 'familyTree'
  | 'mission'
  | 'decor'
  | 'profile'
  | 'settings';

type MenuActionButtonOpts<TDisabled = boolean> = TDisabled extends false
  ? {
      type: MenuActionType;
      onSelect: (selection: MenuActionType) => Promise<void>;
      isDisabled?: TDisabled;
    }
  : {
      type: AvailableDisabledFeatures;
      onSelect: (selection: MenuActionType) => Promise<void>;
      isDisabled?: TDisabled;
    };

export default class MenuActionButton extends ButtonScaleViewWithText {
  constructor(private opts: MenuActionButtonOpts) {
    super({
      ...ui.menuButton,
      icon: ui.icons[opts.type],
      localeText: () => i18n(`mainMenu.${opts.type}`),
      tracking: { feature: 'mainMenu', $subFeature: opts.type },
    });

    this.icon.updateOpts({ scaleMethod: 'contain' });

    if (opts.isDisabled) {
      const { width, height } = this.style;
      this.addSubview(new LockedButtonOverlay({ width, height }));
    }
  }

  onClick = async () => {
    // Show feature disabled popup
    if (this.opts.isDisabled) {
      sounds.sfx.play('ok');

      if (this.opts.type === 'profile' && isPlatformGuest(platform)) {
        await openPopupPromise('popupNativeLineGuestLogin', {
          origin: 'feature',
        });
        return;
      }

      await openPopupPromise('popupFeatureDisabled', {
        feature: this.opts.type,
      });

      sounds.sfx.play('cancel');
    } else {
      await this.opts.onSelect(this.opts.type as MenuActionType);
    }
  };
}
